// Contact Form Panther Labels
export const FormStrings = {
  NAME_PLACEHOLDER_LABEL: 'fullName_label',
  EMAIL_PLACEHOLDER_LABEL: 'email_label',
  FORM_SUBMIT_BUTTON_LABEL: 'formSubmit_label',
  ORIGINAL_INTAKE_FORM_PRIVACY_NOTICE: 'original_intake_form_label',
  OTHER_LABEL: 'other_label',
  SUPPLIER_LABEL: 'supplier_label',
  SUPPLIER_DESCRIPTION: 'supplier_description',
  AWS_CUSTOMER_LABEL: 'awsCustomer_label',
  AWS_CUSTOMER_DESCRIPTION: 'awsCustomer_description',
  VENDOR_LABEL: 'vendor_label',
  VENDOR_DESCRIPTION: 'vendor_description',
  SELLING_PARTNER_LABEL: 'sellingPartner_label',
  SELLING_PARTNER_DESCRIPTION: 'sellingPartner_description',
  TCP_SIGNATORY_LABEL: 'tcpSignatory_label',
  TCP_SIGNATORY_DESCRIPTION: 'tcpSignatory_description',
  AMAZON_CUSTOMER_LABEL: 'amazonCustomer_label',
  AMAZON_CUSTOMER_DESCRIPTION: 'amazonCustomer_description',
  INPUT_TOO_LONG_LABEL: 'inputTooLong_label',
  JOB_TITLE_LABEL: 'jobTitle_label',
  COMPANY_LABEL: 'company_label',
  WEBSITE_LABEL: 'website_label',
  COMPANY_SIZE_LABEL: 'companySize_label',
  COUNTRY_LABEL: 'country_label',
  AMAZON_RELATION_LABEL: 'amazonRelation_label',
  INVALID_EMAIL_LABEL: 'invalidEmail_label',
  INVALID_INPUT_LABEL: 'invalidInput_label',
  ERRORS_PRESENT_DESCRIPTION: 'errorsPresent_description',
  PERSONAL_INFORMATION_HEADER: 'personalInformation_header',
  COMMITMENTS_INFORMATION_HEADER: 'commitmentsInformation_header',
  COMMITMENTS_INFORMATION_HEADER_TWO: 'commitmentsInformation_header2',
  REQUIRED_FIELDS_LABEL: 'requiredFields_label',
  YES_SELECTOR_OPTION: 'yesSelectorOption_label',
  NO_SELECTOR_OPTION: 'noSelectorOption_label',
  SELECT_OPTION: 'selectOption_label',
  IS_MANDATORY: 'isMandatory_label',
  ERROR_YEAR_DATE: 'errorYearDate_label',
  QUESTION_1_ERROR: 'question1Error_label',
  SUBQUESTION_1_ERROR: 'subquestion1Error_label',
  QUESTION_2_ERROR: 'question2Error_label',
  QUESTION_4_ERROR: 'question4Error_label',
  INTAKE_FORM_TITLE: 'intakeFormTitle_label',
  INTAKE_FORM_COPY_TWO: 'intakeFormCopy2_label',
  INTAKE_FORM_COPY_FOUR: 'intakeFormCopy4_label',
  INTAKE_FORM_BACK_BUTTON: 'intakeForm_backButton_label',
  INTAKE_FORM_BACK_BUTTON_MY_ACCOUNT: 'intakeForm_backButton_myAccount_label',
  INTAKE_FORM_HIGHLIGHTED_CARD_TITLE: 'intakeForm_highlightedCard_title',
  INTAKE_FORM_HIGHLIGHTED_CARD_SUBTITLE: 'intakeForm_highlightedCard_subtitle',
  INTAKE_FORM_HIGHLIGHTED_CARD_ITEM_1: 'intakeForm_highlightedCard_item_1',
  INTAKE_FORM_HIGHLIGHTED_CARD_ITEM_2: 'intakeForm_highlightedCard_item_2',
  BACK: 'back',
  CONTINUE: 'continue',
  SAVE_FORM_ERROR_LABEL: 'saveFormError_label',

  // Post-submission thank you page strings (organized by eligibility case)
  // Case 1: Authenticated + US/UK (qualified, self-ID eligible)
  ELIGIBLE_AUTHENTICATED_TOAST_TITLE: 'eligible_authenticated_toastTitle',
  ELIGIBLE_AUTHENTICATED_TOAST_BODY: 'eligible_authenticated_toastBody',
  ELIGIBLE_AUTHENTICATED_TITLE: 'eligible_authenticated_title',
  ELIGIBLE_AUTHENTICATED_CTA: 'eligible_authenticated_cta',

  // Case 2: Unauthenticated + US/UK (qualified, self-ID eligible)
  ELIGIBLE_UNAUTHENTICATED_TOAST_TITLE: 'eligible_unauthenticated_toastTitle',
  ELIGIBLE_UNAUTHENTICATED_TOAST_BODY: 'eligible_unauthenticated_toastBody',
  ELIGIBLE_UNAUTHENTICATED_TITLE: 'eligible_unauthenticated_title',
  ELIGIBLE_UNAUTHENTICATED_CTA: 'eligible_unauthenticated_cta',

  // Case 3: Authenticated + non-US/UK (unqualified, not self-ID eligible)
  INELIGIBLE_AUTHENTICATED_TITLE: 'ineligible_authenticated_title',
  INELIGIBLE_AUTHENTICATED_COPY: 'ineligible_authenticated_copy',
  INELIGIBLE_AUTHENTICATED_CTA: 'ineligible_authenticated_cta',

  // Case 4: Unauthenticated + non-US/UK (unqualified, not self-ID eligible)
  INELIGIBLE_UNAUTHENTICATED_TITLE: 'ineligible_unauthenticated_title',
  INELIGIBLE_UNAUTHENTICATED_COPY: 'ineligible_unauthenticated_copy',
  INELIGIBLE_UNAUTHENTICATED_CTA: 'ineligible_unauthenticated_cta',

  // Case 5: Fallback (user does not meet eligibility — not in qualified value chain)
  FALLBACK_UNQUALIFIED_TITLE: 'fallback_unqualified_title',
  FALLBACK_UNQUALIFIED_COPY: 'fallback_unqualified_copy',
  FALLBACK_UNQUALIFIED_CTA: 'fallback_unqualified_cta',
};

export const IntakeFormQuestionInfo: { [name: string]: { id: string; text: string } } = {
  NET_ZERO_CARBON_TARGET_CRITERIA_QUESTION: {
    id: 'NetZeroTargetsThreeScopesQuestion',
    text: 'intakeFormQuestion1_label',
  },
  SUBQUESTION_1: {
    id: 'NetZeroTargetYearQuestion',
    text: 'intakeFormSubquestion1_label',
  },
  MEASURE_AND_REPORT_CRITERIA_QUESTION: {
    id: 'MeasureReportGreenhouseGasEmissionsQuestion',
    text: 'intakeFormQuestion2_label',
  },
};

export const MarketplaceRedirectStrings = {
  TITLE: 'marketplaceRedirect_title',
  BODY: 'marketplaceRedirect_body',
  CONFIRM_TEXT: 'marketplaceRedirect_confirmText',
  DROPDOWN_LABEL: 'marketplaceRedirect_dropdownLabel',
  CANCEL_BUTTON: 'marketplaceRedirect_cancelButton',
  CONFIRM_BUTTON: 'marketplaceRedirect_confirmButton',
};
